<template>
  <div class="qysl-wrapper hasTabBar" id="qysl-wrapper">
    <div class="title">
      <div class="main_title">{{ $t('enterpriseStrength.mainTitle') }}</div>
      <div class="sub-title">{{ $t('enterpriseStrength.subTitle') }}</div>
    </div>

    <div class="tab-bar-wrapper">
      <div
        v-if="showCityTab"
        :class="['tabbar', { active: activeTab === 0 }]"
        @click="handleTabClick(0)"
      >
        {{ $t('enterpriseStrength.tabCities') }}
      </div>
      <div
        :class="['tabbar', { active: activeTab === 1, last: !showCityTab }]"
        @click="handleTabClick(1)"
      >
        {{ $t('enterpriseStrength.tabBranches') }}
      </div>
    </div>

    <div
      v-if="showCityTab"
      :class="['list-wrapper', 'section', 'index_map', { active: activeTab === 0 }]"
      v-show="activeTab === 0"
    >
      <img class="img" src="@/static/image/map.png" width="1200" height="800" alt="map" />
      <canvas id="range" width="1200" height="800"></canvas>
    </div>

    <div
      :class="['list-wrapper', 'subCom', 'section', { active: activeTab === 1 }]"
      v-show="activeTab === 1"
      @mouseout="handleListMouseOut"
    >
      <a
        v-for="(item, index) in companies"
        :key="item.link"
        :href="resolvedCompanyLink(item)"
        target="_blank"
        :class="['item', { mr: (index + 1) % 3 === 0, active: activeItemIndex === index }]"
        @mousemove="handleItemMouseMove(index)"
      >
        <div class="img">
          <img class="bg" :src="item.img" :alt="$t(item.titleKey)" />
        </div>
        <div class="cotent">
          <div class="title_2">{{ $t(item.titleKey) }}</div>
          <div class="desc">{{ $t(item.descKey) }}</div>
        </div>
        <img class="border" src="@/static/image/index-qysl-border.png" alt="border" />
      </a>
    </div>

    <div class="clear"></div>
  </div>
</template>

<script>
import { resolveLocaleLink } from '@/utils/localeLink'

export default {
  name: 'EnterpriseStrength',
  data() {
    return {
      activeTab: this.showCityTab ? 0 : 1,
      activeItemIndex: -1,
      companies: [
        {
          titleKey: 'enterpriseStrength.c1Title',
          descKey: 'enterpriseStrength.c1Desc',
          img: require('@/static/image/index-qysl1.png'),
          link: '/contact.html#com1'
        },
        {
          titleKey: 'enterpriseStrength.c2Title',
          descKey: 'enterpriseStrength.c2Desc',
          img: require('@/static/image/index-qysl3.png'),
          link: '/contact.html#com2'
        },
        {
          titleKey: 'enterpriseStrength.c3Title',
          descKey: 'enterpriseStrength.c3Desc',
          img: require('@/static/image/index-qysl5.png'),
          link: '/contact.html#com3'
        },
        {
          titleKey: 'enterpriseStrength.c4Title',
          descKey: 'enterpriseStrength.c4Desc',
          img: require('@/static/image/index-qysl3.png'),
          link: '/contact.html#com4'
        },
        {
          titleKey: 'enterpriseStrength.c5Title',
          descKey: 'enterpriseStrength.c5Desc',
          img: require('@/static/image/index-qysl2.png'),
          link: '/contact.html#com5'
        },
        {
          titleKey: 'enterpriseStrength.c6Title',
          descKey: 'enterpriseStrength.c6Desc',
          img: require('@/static/image/index-qysl4.png'),
          link: '/contact.html#com6'
        },
        {
          titleKey: 'enterpriseStrength.c7Title',
          descKey: 'enterpriseStrength.c7Desc',
          img: require('@/static/image/index-qysl7.png'),
          link: '/contact.html#com7'
        },
        {
          titleKey: 'enterpriseStrength.c8Title',
          descKey: 'enterpriseStrength.c8Desc',
          img: require('@/static/image/index-qysl8.png'),
          link: '/contact.html#com8'
        },
        {
          titleKey: 'enterpriseStrength.c9Title',
          descKey: 'enterpriseStrength.c9Desc',
          img: require('@/static/image/index-qysl9.png'),
          link: '/contact.html#com9'
        },
        {
          titleKey: 'enterpriseStrength.c10Title',
          descKey: 'enterpriseStrength.c10Desc',
          img: require('@/static/image/index-qysl10.png'),
          link: '/contact.html#com10'
        },
        {
          titleKey: 'enterpriseStrength.c11Title',
          descKey: 'enterpriseStrength.c11Desc',
          img: require('@/static/image/index-qysl11.png'),
          link: '/contact.html#com11'
        },
        {
          titleKey: 'enterpriseStrength.c12Title',
          descKey: 'enterpriseStrength.c12Desc',
          img: require('@/static/image/index-qysl12.png'),
          link: '/contact.html#com12'
        }
      ]
    }
  },
  computed: {
    showCityTab() {
      const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      return !/^en(?:-|$)/i.test(locale)
    }
  },
  methods: {
    handleItemMouseMove(index) {
      this.activeItemIndex = index
    },
    handleListMouseOut() {
      this.activeItemIndex = -1
    },
    handleTabClick(index) {
      this.activeTab = index
      this.activeItemIndex = -1
    },
    resolvedCompanyLink(item) {
      const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      return resolveLocaleLink(locale, item && item.link)
    }
  }
}
</script>

<style scoped lang="scss">
.qysl-wrapper {
  .section {
    width: 1200px;
    margin: 0 auto;
  }

  .title {
    margin-top: 80px;
    text-align: center;

    .sub-title {
      font-size: 40px;
      color: #333;
      line-height: 1;
    }

    .main_title {
      margin-top: 8px;
      font-size: 72px;
      font-weight: 700;
      color: #e6e6e9;
      line-height: 1;
    }
  }

  .tab-bar-wrapper {
    margin: 48px auto 28px;
    color: #666666;
    font-size: 22px;
    min-height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 32px;

    .tabbar {
      min-height: 38px;
      padding: 0 24px;
      text-align: center;
      line-height: 38px;
      cursor: pointer;
      white-space: nowrap;
      transition: all 0.2s linear;

      &.active {
        color: #ffffff;
        background: #1c51a3;
        border-radius: 38px;
      }

      &.last {
        margin-right: 0;
      }
    }
  }

  .list-wrapper {
    display: none;

    .item {
      cursor: pointer;
      position: relative;
      float: left;
      height: 370px;
      width: 374px;
      margin-top: 40px;
      margin-right: 38px;
      text-decoration: none;

      .img {
        overflow: hidden;
        height: 270px;

        img {
          width: 100%;
          height: 100%;
          transition: all 0.5s linear;
          object-fit: cover;
        }
      }

      .cotent {
        position: relative;
        margin-top: 16px;
        text-align: left;
        .title_2 {
          color: #333333;
          font-size: 18px;
        }

        .desc {
          margin-top: 8px;
          color: #666666;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 22px;
          font-size: 14px;
        }
      }

      .border {
        width: 0;
        height: 9px;
        position: absolute;
        left: 0;
        bottom: 0;
        transition: all 0.2s linear;
      }

      &.mr {
        margin-right: 0;
      }

      &.active {
        .border {
          width: 100px;
        }

        .img {
          .bg {
            transform: scale(1.5);
          }
        }
      }
    }

    #range {
      width: 100%;
      height: 100%;
    }

    &.index_map {
      position: relative;
      height: 800px;

      .img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }

      #range {
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    &.subCom {
      height: 1660px;
    }

    &.active {
      display: block;
    }
  }

  .clear {
    height: 80px;
    clear: both;
  }
}
</style>
